// Lightweight client-side A/B testing: sticky variant assignment per visitor
// (localStorage) + fire-and-forget event tracking to the public backend.
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function getVariant(experiment, variants) {
  const key = `ab_${experiment}`;
  let v = null;
  try {
    v = localStorage.getItem(key);
  } catch (_e) {}
  if (!v || !variants.includes(v)) {
    v = variants[Math.floor(Math.random() * variants.length)];
    try {
      localStorage.setItem(key, v);
    } catch (_e) {}
  }
  return v;
}

export function trackAb(experiment, variant, event) {
  try {
    fetch(`${BACKEND}/api/ab/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ experiment, variant, event }),
      keepalive: true,
    }).catch(() => {});
  } catch (_e) {}
}
